import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _temp;

/**
 * @date 2019-03-04
 * @author WY yang.wang06@hand-china.com
 * @copyright ® HAND 2019
 */
import React from 'react';
import { withRouter, Route } from 'dva/router';
import { connect } from 'dva';
import Exception from "../Exception";
import { extractAccessTokenFromHash, extractRefreshTokenFromHash, extractErrorMessageFromSearch, setAccessToken, setRefreshToken, getCurrentOrganizationId, getCurrentRole, setSession, getResponse } from "../../utils/utils";
import { getEnvConfig } from "../../utils/iocUtils";
var AuthorizedRoute = (_dec = connect(), withRouter(_class = _dec(_class = (_temp = /*#__PURE__*/function (_React$Component) {
  _inherits(AuthorizedRoute, _React$Component);
  var _super = _createSuper(AuthorizedRoute);
  function AuthorizedRoute() {
    var _this;
    _classCallCheck(this, AuthorizedRoute);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.config = getEnvConfig();
    _this.state = {
      isAuthorized: false,
      isException: false,
      responseStatusCode: undefined
    };
    return _this;
  }
  _createClass(AuthorizedRoute, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        dispatch = _this$props.dispatch,
        history = _this$props.history,
        location = _this$props.location;
      var token = extractAccessTokenFromHash(window.location.hash);
      var refreshToken = extractRefreshTokenFromHash(window.location.hash);
      var errorMessage = extractErrorMessageFromSearch(window.location.search);
      if (errorMessage) {
        history.push({
          pathname: '/public/error-message',
          state: {
            message: errorMessage
          }
        });
        return;
      } else if (token) {
        setAccessToken(token, 60 * 60);
        setRefreshToken(refreshToken, 60 * 60); // 保留上次退出时的页面路径和search

        history.push({
          pathname: location.pathname,
          search: location.search
        });
      }
      dispatch({
        type: 'user/fetchCurrent'
      }).then(function (res) {
        if (res) {
          if (!(res instanceof Error)) {
            if (!res.failed) {
              // 请求 self 接口成功
              // 设置当前语言到session
              setSession('language', res.language);
              dispatch({
                type: 'global/baseInit',
                payload: {
                  language: res.language,
                  // 加载菜单国际化
                  organizationId: getCurrentOrganizationId(),
                  // FIXME: 等 菜单接口好后删除
                  roleId: getCurrentRole().id
                }
              }).then(function () {
                _this2.setState({
                  isAuthorized: true
                });
              });
              dispatch({
                type: 'global/checkEntryDirectory'
              }).then(function (resp) {
                if (getResponse(resp)) {
                  var obj = resp.find(function (temp) {
                    return temp.entryCategory === 'NAVIGATE' && temp.entryValue === 'HZERO.TRACE_LOG';
                  });
                  if (obj === null || obj === void 0 ? void 0 : obj.enableFlag) {
                    dispatch({
                      type: 'global/getTraceStatus'
                    });
                  }
                }
              });
              dispatch({
                type: 'global/changeLayoutCollapsed',
                payload: {
                  collapsed: res.userThemeConfig.menuBarState !== 1
                }
              });
            } else {
              // 清除首屏loading
              var loader = document.querySelector('#loader-wrapper');
              _this2.setState({
                isException: true
              });
              if (loader) {
                loader.parentNode.removeChild(loader);
              }
              history.push({
                pathname: '/public/self-error',
                state: {
                  message: res.message
                }
              });
            }
          } else {
            var _res$response, _res$response2;

            // 其他错误
            _this2.setState({
              isException: true,
              responseStatusCode: res === null || res === void 0 ? void 0 : (_res$response = res.response) === null || _res$response === void 0 ? void 0 : _res$response.status
            }); // 清除首屏loading

            var _loader = document.querySelector('#loader-wrapper');
            if (_loader) {
              document.body.removeChild(_loader);
            }
            if ((res === null || res === void 0 ? void 0 : (_res$response2 = res.response) === null || _res$response2 === void 0 ? void 0 : _res$response2.status) === 403) {
              history.push('/exception/403');
            } else {
              history.push('/exception/500');
            }
          }
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        _render = _this$props2.render,
        rest = _objectWithoutProperties(_this$props2, ["render"]);
      var _this$state = this.state,
        isAuthorized = _this$state.isAuthorized,
        isException = _this$state.isException,
        responseStatusCode = _this$state.responseStatusCode; // eslint-disable-next-line no-nested-ternary

      return isAuthorized === true ? /*#__PURE__*/React.createElement(Route, Object.assign({}, rest, {
        render: function render(props) {
          return _render(props);
        }
      })) : isException === true ? /*#__PURE__*/React.createElement(Exception, {
        type: responseStatusCode || 500
      }) : null;
    }
  }]);
  return AuthorizedRoute;
}(React.Component), _temp)) || _class) || _class);
export { AuthorizedRoute as default };